export default __webpack_public_path__ + "static/media/Aura-Egg__13.352ec4fc.png";